import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {},
  error: undefined,
  selectable: false,
  selectedRowKeys: [],
  selectedRows: [],
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.modulo.socios.list.busy = true;
    state.modulo.socios.list.filters = {
      ...state.modulo.socios.list.filters,
      ...meta,
    };
  });

  try {
    const params = {
      ...meta,
    };

    const response = await Http.get('api/socios', { params });

    store.setState((state) => {
      state.modulo.socios.list.busy = false;
      state.modulo.socios.list.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.socios.list.busy = false;
      state.modulo.socios.list.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.modulo.socios.list.error = undefined;
};

const setSelectable = (store, selectable) => (state) => {
  state.modulo.socios.list.selectable = selectable;
};

const setSelection = (store, selectedRows, selectedRowKeys) => {
  return (state) => {
    state.modulo.socios.list = {
      ...state.modulo.socios.list,
      selectedRows: selectedRows,
      selectedRowKeys: selectedRowKeys,
    };
  };
};

const clearSelection = () => {
  return (state) => {
    state.modulo.socios.list = {
      ...state.modulo.socios.list,
      selectable: false,
      selectedRowKeys: [],
      selectedRows: [],
    };
  };
};

const actions = {
  paginate,
  resetError,
  setSelectable,
  setSelection,
  clearSelection,
};

const SociosDeNegocioListStore = {
  state: () => initialState,
  actions,
};

export default SociosDeNegocioListStore;
